import UltimateGuide from './ultimate-guide';

export default UltimateGuide;
